import type DocumentTemplateView from '@UI/Store/DocumentTemplates/Views/Document/DocumentTemplateView';
import { AbstractValidatedClass, Joi, ValidatedClass, constraint } from '@verclam/form-validator';

export type DocumentTemplateEditFormArgs = {
	name: string;
	description: string;
};

/** Only carries `name` and `description`: the document type and the file never change through this
 * panel — a new file goes through the deposit sidebar's `version` mode instead. */
@ValidatedClass()
class DocumentTemplateEditFormData extends AbstractValidatedClass<DocumentTemplateEditFormArgs> {
	@constraint(Joi.string().max(180), () => 'Le nom ne peut pas dépasser 180 caractères.')
	@constraint(Joi.string().required(), () => 'Le nom du gabarit est obligatoire.')
	public readonly name: string;

	@constraint(
		Joi.string().max(2000).allow(''),
		() => 'La description ne peut pas dépasser 2000 caractères.',
	)
	public readonly description: string;

	constructor(data: DocumentTemplateEditFormArgs) {
		super(data);
		this.name = data.name;
		this.description = data.description;
		Object.freeze(this);
	}

	static createEmpty(): DocumentTemplateEditFormData {
		return new DocumentTemplateEditFormData({ name: '', description: '' });
	}

	static fromView(template: DocumentTemplateView): DocumentTemplateEditFormData {
		return new DocumentTemplateEditFormData({
			name: template.name,
			description: template.description ?? '',
		});
	}

	setName(name: string): this {
		return this.cloneWith({ name } as Partial<DocumentTemplateEditFormArgs>);
	}

	setDescription(description: string): this {
		return this.cloneWith({ description } as Partial<DocumentTemplateEditFormArgs>);
	}
}

export default DocumentTemplateEditFormData;
